export interface NumberConstraints {
  min?: number
  max?: number
  integerOnly?: boolean
}

export function validateNumberAnswer(
  value: number,
  constraints: NumberConstraints,
  label: string
): true | string {
  if (!Number.isFinite(value)) return `${label} must be a number`
  if (constraints.integerOnly && !Number.isInteger(value)) return `${label} must be a whole number`
  if (constraints.min !== undefined && value < constraints.min) return `${label} is too small`
  if (constraints.max !== undefined && value > constraints.max) return `${label} is too large`
  return true
}
